<script>
	export default {
		props: ['product', 'workspace', 'mustRateVocabWordsNow', 'submitAssignment', 'offlineMode'],
		components: {
			'vocab-changer-activity': require('components/vocab-changer-activity.vue').default,
			'vocab-builder-activity': require('components/vocab-builder-activity.vue').default,
			'vocab-matcher-activity': require('components/vocab-matcher-activity.vue').default,
			'vocab-rate-words': require('components/vocab-rate-words.vue').default
		},
		data() {
			return {
				done: false
			};
		},
		methods: {
			nextWSTab() {
				this.$emit('next-workspace-tab');
				return true;
			},
			markDone(ev) {
				this.done = true;
				$('.tab-panel-body').scrollTop(0);
				$(window).scrollTop(0);
			}
		},
		computed: {
			showTts() {
				return this.offlineMode === false && !!this.product && !!this.workspace;
			},
			allWords() {
				return (this.product.vocab && this.product.vocab.support.word_list) || [];
			},
			productVocabActivity() {
				return (this.product.vocab && this.product.vocab.activity) || {};
			},
			dataLoaded() {
				return this.workspace && this.workspace.opts && this.product;
			},
			showChanger() {
				const activities = this.productVocabActivity;
				return (
					this.dataLoaded &&
					!this.mustRateVocabWordsNow &&
					this.workspace.opts.vocabularyActivities &&
					this.workspace.opts.vocabularyActivities.indexOf('word_changer') !== -1 &&
					!!activities.word_changer
				);
			},
			showBuilder() {
				const activities = this.productVocabActivity;
				return (
					this.dataLoaded &&
					!this.mustRateVocabWordsNow &&
					this.workspace.opts.vocabularyActivities &&
					this.workspace.opts.vocabularyActivities.indexOf('word_builder') !== -1 &&
					!!activities.word_builder
				);
			},
			showMatcher() {
				const activities = this.productVocabActivity;
				return (
					this.dataLoaded &&
					!this.mustRateVocabWordsNow &&
					this.workspace.opts.vocabularyActivities &&
					this.workspace.opts.vocabularyActivities.indexOf('word_matcher') !== -1 &&
					!!activities.word_matcher
				);
			},
			allComplete() {
				if (!this.showChanger && !this.showBuilder && !this.showMatcher) {
					return false;
				}

				if (this.showChanger && !this.workspace.scoreState.va.wc) {
					return false;
				}

				if (this.showMatcher && !this.workspace.scoreState.va.wm) {
					return false;
				}

				if (this.showBuilder && !this.workspace.scoreState.va.wb) {
					return false;
				}

				return true;
			}
		}
	};
</script>
<template>
	<div class="main-content wrapper vocab-activity-tab">
		<vocab-rate-words
			v-if="mustRateVocabWordsNow"
			:show-tts="showTts"
			:product="product"
			:workspace="workspace"></vocab-rate-words>

		<div v-if="done">
			<vocab-rate-words
				:show-tts="showTts"
				:product="product"
				:workspace="workspace"
				post
				@vocab-rtw-submitted="nextWSTab"
				:done-label="workspace.s === 'a' && workspace.opts && workspace.opts.qs && workspace.opts.qs.length == 0 ? 'Submit' : 'Done'"></vocab-rate-words>
		</div>
		<div v-if="!done">
			<section
				v-if="showBuilder"
				class="activity">
				<vocab-builder-activity
					:word-list="allWords"
					:show-tts="showTts"
					:word-builder="productVocabActivity.word_builder"
					:product-id="workspace.productId"
					:assignment-id="workspace.aid"
					:activity-state="workspace.scoreState.va"></vocab-builder-activity>
			</section>
			<section
				v-if="showMatcher"
				class="activity">
				<vocab-matcher-activity
					:show-tts="showTts"
					:word-list="allWords"
					:product="product"
					:word-matcher="productVocabActivity.word_matcher"
					:assignment-id="workspace.aid"
					:activity-state="workspace.scoreState.va"></vocab-matcher-activity>
			</section>
			<section
				v-if="showChanger"
				class="activity">
				<vocab-changer-activity
					:word-list="allWords"
					:show-tts="showTts"
					:word-changer="productVocabActivity.word_changer"
					:product="product"
					:assignment-id="workspace.aid"
					:activity-state="workspace.scoreState.va"></vocab-changer-activity>
			</section>

			<template v-if="allComplete">
				<nav
					v-if="workspace.s !== 's'"
					class="text-right">
					<button
						data-test-vocab="done"
						class="button -large"
						@click="markDone">
						Done
					</button>
				</nav>
				<vocab-rate-words
					v-else="workspace.s === 's'"
					:show-tts="showTts"
					results
					:product="product"
					:workspace="workspace"></vocab-rate-words>
			</template>
		</div>
	</div>
</template>
